import React from 'react';
import { hero, heroStats, meta, images } from '../data/caseStudy';
import { MetricCard } from './MetricCard';
import { Pill } from './ui/Pill';
export function Hero() {
  return <header className="grid-navy w-full text-white" data-id="element-21" data-mp="9ktfls818azv">
      <div className="mx-auto w-[1200px] px-20 pb-20 pt-16" data-id="element-22" data-mp="9lbgj25n3de4">
        <div className="flex items-center justify-between" data-id="element-23" data-mp="4m8l89fgoljc">
          <div className="flex items-center gap-3" data-id="element-24" data-mp="4jm7fs1z99so">
            <span className="accent-rule h-6 w-1 rounded-full" aria-hidden="true" data-id="element-25" data-mp="128fqlljlahwr" />
            <span className="font-display text-[15px] font-semibold tracking-tight text-white" data-id="element-26" data-mp="x9uspsrt8abh">
              Lumen Platform
            </span>
            <span className="font-sans text-[13px] text-white/40" data-id="element-27" data-mp="s9ggrzn38g86">FGE NexantECA</span>
          </div>
          <Pill variant="navy" data-id="element-28" data-mp="nbyid36p5jef">Product design case study</Pill>
        </div>

        <h1 className="mt-16 max-w-[900px] font-display text-[62px] font-semibold leading-[1.04] tracking-[-0.032em] text-white" data-id="element-29" data-mp="3d2bkbqsid1w2">
          {hero.title}
        </h1>

        <p className="mt-8 max-w-[720px] font-sans text-[19px] font-light leading-[1.6] text-white/65" data-id="element-30" data-mp="3j7zf9iqmlsgo">
          {hero.subtitle}
        </p>

        <div className="mt-10 flex flex-wrap gap-2" data-id="element-31" data-mp="3o73ouahgps7j">
          <Pill variant="outline" data-id="element-32" data-mp="39al7s8moke0i">Interactive map</Pill>
          <Pill variant="navy" data-id="element-33" data-mp="39a38f34q1jod">Layer controls</Pill>
          <Pill variant="navy" data-id="element-34" data-mp="3e8whmjcz6oiq">Design system</Pill>
          <Pill variant="navy" data-id="element-35" data-mp="3ebiripnc9g44">Brand Development</Pill>
        </div>

        <dl className="mt-14 grid grid-cols-4 gap-x-8 rounded-2xl border border-white/10 bg-white/[0.04] px-8 py-7" data-id="element-36" data-mp="30h9b7qpbjzm8">
          {meta.map(item => <div key={item.label} data-id="element-37" data-mp="2qjv96w457ddg">
              <dt className="font-sans text-[11px] font-medium uppercase tracking-[0.18em] text-white/40" data-id="element-38" data-mp="2qkwjuzh8xxun">
                {item.label}
              </dt>
              <dd className="mt-3 font-display text-[16px] font-medium leading-snug text-white" data-id="element-39" data-mp="2vglkl6505ksj">
                {item.value}
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 overflow-hidden rounded-2xl border border-white/10" data-id="element-40" data-mp="2lmuz8a469qh2">
          <img src={images.heroDevice} alt="The Lumen global overview dashboard shown on a laptop: market analysis cards, a scenario engine panel, a supply and demand chart and the global infrastructure globe." className="block w-full" data-id="element-41" data-mp="s3ckw8bgjfpi" />
        </div>

        <div className="mt-8 grid grid-cols-4 gap-5" data-id="element-42" data-mp="deq4e3a3ghwp">
          {heroStats.map(stat => <MetricCard key={stat.label} stat={stat} tone="navy" data-id="element-43" data-mp="1b0dte347zxy7" />)}
        </div>
      </div>
    </header>;
}